
const X9 = {
  header: {
    category: "Panoráma Röntgen",
    model: "MyRay X9 Pro",
    tagline: "A jövőre tervezve, neked építve.",
  },

  hero: {
    image: "/uploads/x9.png",
    buttonText: "Digitális bemutatóterem",
    title: "MyRay X9 Pro",
    description:
      "A Hyperion X9 Pro mindent biztosít, amire szüksége van a fejlett 2D, 3D és kefalometriai diagnosztikai képekhez. Gyors, biztonságos, kiváló minőségű diagnózist biztosít, mindenkor az Ön igényeihez igazítva.",
    showroom: "https://www.vitshowroom.it/interactive/myray/index.php?IDmodello=1074&param=sala1,162.94,-6.55,94.80,4,ENG"
  },

  description: {
    title: "Jellemzők",
    columns: [
      [
        "Nagy felbontású képek",
        "Időben tartó megbízhatóság",
        "Fókuszban a páciens egészségére",
      ],
      [
        "Bővíthető rendszer",
        "Kiemelkedő ergonómia",
        "Korszerű dizájn"
      ],
    ],
    image: "/uploads/x9-pano.jpg",
  },

  sections: [
    {
      title: "Tulajdonságok",
      cards: [
        {
          title: "Bővíthető rendszer",
          description: "Kezdhet egy alapkonfigurációval, és a praxis bővülésével új funkciókat is hozzáadhat. A Hyperion X9 Pro teljes mértékben konfigurálható. Moduláris, skálázható kialakítása lehetővé teszi a szakemberek számára, hogy könnyen és költséghatékonyan váltsanak az alapverzióról a fejlettebb verzióra.",
        },
        {
          title: "Nagy felbontású képek",
          description: "A SuperHD felbontású 2D és 3D képek kiemelkedő részletgazdagságot biztosítanak, még alacsony dózisok esetén is, így mindenkor pontos diagnózist biztosítanak. A Cone Beam (CBCT) technológia akár 68 μm-es részletes szkennelést is lehetővé tesz fogászati, fogszabályozási és fül-orr-gégészeti elemzésekhez. A szkennelés után az integrált szoftver lehetővé teszi a képek egyszerű kezelését, megosztását vagy beépítését a klinikai munkafolyamatba.",
        },
        {
          title: "Kiemelkedő ergonómia",
          description: "A lézeres követésnek és a Face to Face ergonómiának köszönhetően a páciens gyors és egyszerű pozicionálása kényelmes, stresszmentes vizsgálatokat tesz lehetővé. A teljes modularitás azt jelenti, hogy a rendszer frissíthető a változó klinikai igényekhez anélkül, hogy ki kellene cserélni.",
        },
      ],
    },
    {
      title: "Munkafolyamat",
      cards: [
        {
          title: "Full Touch vezérlőpanel",
          description: "A közvetlenül a gépen elhelyezett 10 hüvelykes, teljes érintőképernyős kezelőpanel lehetővé teszi az előre beállított programok gyors kiválasztását és optimalizálja a munkafolyamatot. A Face to Face rendszer és a lézersugarak könnyedén vezetik el a helyes pácienspozicionáláshoz, biztosítva a precíz és kényelmes szkennelést.",
        },
        {
          title: "Interaktív nézet FOV",
          description: "Az Interaktív Nézet FOV opció lehetővé teszi a szkennelési terület méretének és pozíciójának újradefiniálását közvetlenül a páciens arcán, két kamerával frontálisan és laterálisan rögzítve a képeket a gépen található kezelőpanel segítségével. A Scout View rendszer lehetővé teszi a térfogat igazítását az érdeklődési területhez közvetlenül a számítógépről. Így két képet (sagittális és frontális) jeleníthet meg, amelyeket ultra alacsony emisszióval készítettek, és precízen módosíthatja a szkennelési területet. Az integrált szoftvernek köszönhetően gyorsan és egyszerűen kezelheti, feldolgozhatja és megoszthatja a képeket, könnyedén beillesztve azokat a klinikai munkafolyamatba.",
        },
      ],
    },
    {
      title: "Rögzítsen minden részletet",
      cards: [
        {
          title: "Közvetlen konverziós érzékelő",
          description: "A DC'' direkt konverziós érzékelő ultra alacsony dózisú SuperHD képeket biztosít a röntgensugarak közvetlen elektromos jelekké alakításával. A nagy teljesítményű képjavító (PiE) szűrők minden részletet optimalizálnak, még a gyors szkennelések, például a QuickPAN és a QuickCEPH esetén is.",
        },
        {
          title: "MultiPAN funkció",
          description: "A MultiPAN funkció lehetővé teszi, hogy egyetlen szkennelés során 5 (standard érzékelővel) és 11 fókuszréteget generáljon egy közvetlen konverziós érzékelővel; ezt követően egyszerűen válassza ki azt, amelyik a legjobban megfelel az egyes diagnosztikai igényeknek. A PAN szkennelés MRT-t (morfológiafelismerő technológiát) és az iPAN protokollt használ a kiváló minőségű panorámaképek automatikus létrehozásához. Egy élvonalbeli algoritmus választja ki a legjobb fókuszt.",
        },
         {
          title: "Ceph kar",
          description: "A kompakt, megfordítható kefalometriai kar könnyen alkalmazkodik az Ön igényeihez, így ultragyors vagy kiváló minőségű szkennelési lehetőségeket kínál.",
        },
      ],
    },
    {
      title: "3D klinikai képek",
      cards: [
        {
          title: "Gyors 360°-os szkennelés",
          description: "A gyors 360°-os szkennelés lehetővé teszi a részletes képek gyors rögzítését, miközben csökkenti a műtermékeket és javítja a képminőséget. A továbbfejlesztett generátor optimalizálja a röntgensugárzás kibocsátását, így tiszta képeket eredményez még alacsony dózisok és rövid expozíciós idők esetén is.",
        },
        {
          title: "3D panel",
          description: "A nagyméretű, érzékeny és precíziós 3D panel lehetővé teszi a fogazat és a felső légutak teljes térfogatának kivételes részletességgel történő képalkotását. A legmodernebb technológiának és az optimalizált protokolloknak köszönhetően a Hyperion X9 Pro rendkívül részletes 3D klinikai képeket biztosít, segítve a gyors diagnózist és a pontos kezelést, bármilyen klinikai igény is legyen.",
        },
      ],
    },
  ],
};

export default X9;